export default "8d0525b894cf39194ce586bf5dbcdc38.svg";